<template>
  <ul class="menu-nav">
    <router-link
      to="/home"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city" />
          <span class="menu-text">Home</span>
        </a>
      </li>
    </router-link>

    <li class="menu-section">
      <h4 class="menu-text">Provinsi</h4>
      <i class="menu-icon flaticon-more-v2" />
    </li>

    <router-link
      to="/jateng"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-rhombus" />
          <span class="menu-text">Jateng</span>
        </a>
      </li>
    </router-link>

    <router-link to="/ntt" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-rhombus" />
          <span class="menu-text">NTT</span>
        </a>
      </li>
    </router-link>

    <!-- --------------------- -->

    <template v-if="isDevelopment">
      <li class="menu-section">
        <h4 class="menu-text">Components</h4>
        <i class="menu-icon flaticon-more-v2" />
      </li>

      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }"
      >
        <a href="#" class="menu-link menu-toggle">
          <i class="menu-icon flaticon2-digital-marketing" />
          <span class="menu-text">Vue Bootstrap</span>
          <i class="menu-arrow" />
        </a>
        <div class="menu-submenu">
          <span class="menu-arrow" />
          <ul class="menu-subnav">
            <li aria-haspopup="true" class="menu-item menu-item-parent">
              <span class="menu-link">
                <span class="menu-text">Vue Bootstrap</span>
              </span>
            </li>

            <router-link
              to="/vue-bootstrap/alert"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Alert</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/badge"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Badge</span>
                </a>
              </li>
            </router-link>

            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item menu-item-submenu"
              v-bind:class="{
                'menu-item-open': hasActiveChildren('/vue-bootstrap/button'),
              }"
            >
              <a href="#" class="menu-link menu-toggle">
                <i class="menu-bullet menu-bullet-dot">
                  <span />
                </i>
                <span class="menu-text">Buttons</span>
                <i class="menu-arrow" />
              </a>
              <div class="menu-submenu">
                <span class="menu-arrow" />
                <ul class="menu-subnav">
                  <li aria-haspopup="true" class="menu-item menu-item-parent">
                    <span class="menu-link">
                      <span class="menu-text" />
                    </span>
                  </li>

                  <router-link
                    to="/vue-bootstrap/button"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Button</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/button-group"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Button Group</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/button-toolbar"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Button Toolbar</span>
                      </a>
                    </li>
                  </router-link>
                </ul>
              </div>
            </li>

            <router-link
              to="/vue-bootstrap/card"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Card</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/carousel"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Carousel</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/collapse"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Collapse</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/dropdown"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Dropdown</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/embed"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Embed</span>
                </a>
              </li>
            </router-link>

            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item menu-item-submenu"
              v-bind:class="{
                'menu-item-open': hasActiveChildren('/vue-bootstrap/form'),
              }"
            >
              <a href="#" class="menu-link menu-toggle">
                <i class="menu-bullet menu-bullet-dot">
                  <span />
                </i>
                <span class="menu-text">Form</span>
                <i class="menu-arrow" />
              </a>
              <div class="menu-submenu">
                <span class="menu-arrow" />
                <ul class="menu-subnav">
                  <li aria-haspopup="true" class="menu-item menu-item-parent">
                    <span class="menu-link">
                      <span class="menu-text" />
                    </span>
                  </li>

                  <router-link
                    to="/vue-bootstrap/form"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/form-checkbox"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form Checkbox</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/form-file"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form File</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/form-group"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form Group</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/form-input"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form Input</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/form-radio"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form Radio</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/form-select"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form Select</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/form-textarea"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Form Textarea</span>
                      </a>
                    </li>
                  </router-link>
                </ul>
              </div>
            </li>

            <router-link
              to="/vue-bootstrap/image"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Image</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/input-group"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Input Group</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/jumbotron"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Jumbotron</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/layout-grid-system"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Layout and Grid System</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/link"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Link</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/list-group"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">List group</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/media"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Media</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/modal"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Modal</span>
                </a>
              </li>
            </router-link>

            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item menu-item-submenu"
              v-bind:class="{
                'menu-item-open': hasActiveChildren('/vue-bootstrap/nav'),
              }"
            >
              <a href="#" class="menu-link menu-toggle">
                <i class="menu-bullet menu-bullet-dot">
                  <span />
                </i>
                <span class="menu-text">Navigation</span>
                <i class="menu-arrow" />
              </a>
              <div class="menu-submenu">
                <span class="menu-arrow" />
                <ul class="menu-subnav">
                  <li aria-haspopup="true" class="menu-item menu-item-parent">
                    <span class="menu-link">
                      <span class="menu-text" />
                    </span>
                  </li>

                  <router-link
                    to="/vue-bootstrap/nav"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Nav</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/navbar"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Navbar</span>
                      </a>
                    </li>
                  </router-link>
                </ul>
              </div>
            </li>

            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item menu-item-submenu"
              v-bind:class="{
                'menu-item-open': hasActiveChildren(
                  '/vue-bootstrap/pagination'
                ),
              }"
            >
              <a href="#" class="menu-link menu-toggle">
                <i class="menu-bullet menu-bullet-dot">
                  <span />
                </i>
                <span class="menu-text">Pagination</span>
                <i class="menu-arrow" />
              </a>
              <div class="menu-submenu">
                <span class="menu-arrow" />
                <ul class="menu-subnav">
                  <li aria-haspopup="true" class="menu-item menu-item-parent">
                    <span class="menu-link">
                      <span class="menu-text" />
                    </span>
                  </li>

                  <router-link
                    to="/vue-bootstrap/pagination"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Pagination</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/pagination-nav"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Pagination Nav</span>
                      </a>
                    </li>
                  </router-link>
                </ul>
              </div>
            </li>

            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item menu-item-submenu"
              v-bind:class="{
                'menu-item-open': hasActiveChildren('/vue-bootstrap/notify'),
              }"
            >
              <a href="#" class="menu-link menu-toggle">
                <i class="menu-bullet menu-bullet-dot">
                  <span />
                </i>
                <span class="menu-text">Notify</span>
                <i class="menu-arrow" />
              </a>
              <div class="menu-submenu">
                <span class="menu-arrow" />
                <ul class="menu-subnav">
                  <li aria-haspopup="true" class="menu-item menu-item-parent">
                    <span class="menu-link">
                      <span class="menu-text" />
                    </span>
                  </li>

                  <router-link
                    to="/vue-bootstrap/notify-popover"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Popover</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/notify-toasts"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Toasts</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/notify-tooltip"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Tooltip</span>
                      </a>
                    </li>
                  </router-link>
                </ul>
              </div>
            </li>

            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item menu-item-submenu"
              v-bind:class="{
                'menu-item-open': hasActiveChildren('/vue-bootstrap/progress'),
              }"
            >
              <a href="#" class="menu-link menu-toggle">
                <i class="menu-bullet menu-bullet-dot">
                  <span />
                </i>
                <span class="menu-text">Progress</span>
                <i class="menu-arrow" />
              </a>
              <div class="menu-submenu">
                <span class="menu-arrow" />
                <ul class="menu-subnav">
                  <li aria-haspopup="true" class="menu-item menu-item-parent">
                    <span class="menu-link">
                      <span class="menu-text" />
                    </span>
                  </li>

                  <router-link
                    to="/vue-bootstrap/progress"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Progress</span>
                      </a>
                    </li>
                  </router-link>

                  <router-link
                    to="/vue-bootstrap/progress-spinner"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[
                        isActive && 'menu-item-active',
                        isExactActive && 'menu-item-active',
                      ]"
                    >
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span class="menu-text">Spinner</span>
                      </a>
                    </li>
                  </router-link>
                </ul>
              </div>
            </li>

            <router-link
              to="/vue-bootstrap/table"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Table</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/vue-bootstrap/tabs"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span class="menu-text">Tabs</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>

      <li class="menu-section">
        <h4 class="menu-text">Custom</h4>
        <i class="menu-icon flaticon-more-v2" />
      </li>

      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{
          'menu-item-open': hasActiveChildren('/custom-plugins'),
        }"
      >
        <a href="#" class="menu-link menu-toggle">
          <i class="menu-icon flaticon2-image-file" />
          <span class="menu-text">Plugins</span>
          <i class="menu-arrow" />
        </a>
        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
          <ul class="menu-subnav">
            <router-link
              to="/custom-plugins/cropper"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span /></i>
                  <span class="menu-text">Cropper</span>
                </a>
              </li>
            </router-link>
            <router-link
              to="/custom-plugins/treeselect"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span /></i>
                  <span class="menu-text">Treeselect</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>

      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{
          'menu-item-open': hasActiveChildren('/custom-pages'),
        }"
      >
        <a href="#" class="menu-link menu-toggle">
          <i class="menu-icon far fa-user" />
          <span class="menu-text">Pages</span>
          <i class="menu-arrow" />
        </a>
        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
          <ul class="menu-subnav">
            <router-link
              to="/custom-pages/profile"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]"
              >
                <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-bullet menu-bullet-dot"><span /></i>
                  <span class="menu-text">Profile</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'KTMenu',
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1
    },
  },
  computed: {
    isDevelopment() {
      if (process.env.VUE_APP_MODE === 'development') {
        return true
      }
      return false
    },
  },
}
</script>
